import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from '@/store/auth'
import contracts from '@/store/contracts'
import settings from '@/store/settings'

Vue.use(Vuex)

const contractsState = createPersistedState({
  paths: ['contracts', 'auth']
})

export default new Vuex.Store({
  strict: true,
  plugins: [
    contractsState
  ],
  modules: {
    auth,
    contracts,
    settings
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js